import React from 'react'
import { Link } from 'react-router-dom'

function Logo() {
    return (
        <Link to="/">
            <img height={120} src={require('../../assets/images/newfile/Property 1=Variant2 (1).svg').default} />
        </Link>
    )
}
export default Logo
